module.exports = __webpack_public_path__ + "static/media/page_04.310db8ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/page_04.jpg
// module id = 1830
// module chunks = 0 1